import api from '../api';
class SocialService {
    getFriends(name) {
        return api.get(`/friends?name=${encodeURIComponent(name)}`);
    }
    getFriendStatus(address) {
        return api.get(`/users/address/${address}`);
    }
    deleteFriend(userId) {
        return api.post(`/friends/remove/${userId}`);
    }
    inviteFriend(userId) {
        return api.post(`/friends/invite/${userId}`);
    }
    approveInvite(inviteId) {
        return api.post(`/friends/approve-invite/${inviteId}`);
    }
    disproveInvite(inviteId) {
        return api.post(`/friends/disprove-invite/${inviteId}`);
    }
    removeFriendsRequest(userId) {
        return api.delete(`/friends/invite/${userId}`);
    }
}
export default new SocialService();
